<template>
  <div id="company_detail">
    <my-header :has_back=true></my-header>
    <div class="contents">

      <div class="title">
        <div class="company_name">{{company.company_name}}</div>
        <div class="star">
          <star-rating
            v-bind:increment="0.5"
            v-model="mean_review_poinst"
            :star-size=15
            :read-only="true"
          ></star-rating>
        </div>
        <div class="star_sum">({{review_all.length}})</div>
      </div>

      <div class="images">
        <img src="@/assets/no_image.png">
        <img src="@/assets/no_image2.png">
        <img src="@/assets/no_image.png">
      </div>

      <div class="key area_key">
        活動エリア
        <div
          class="edit"
          @click="edit(company)"
        >
          編集
        </div>
        <span class="ok">誰でもOK!</span>
      </div>
      <div class="item">
        <span
          v-for="(value, area) in company.area_list"
          :key="area"
        >
          <span v-if="value">
            {{area}}&nbsp;&nbsp;
          </span>
        </span>
      </div>

      <div class="key">
        <span class="icon"><i class="fas fa-phone"></i></span>
        電話番号
      </div>
      <div class="item">
        <a :href="to_phone_number(company.phone_number)">
          {{company.phone_number}}
        </a>
      </div>

      <div class="key">
        <span class="icon"><i class="far fa-clock"></i></span>
        営業時間
      </div>

      <div class="item">
        {{company.business_hours}}
      </div>

      <div class="key">
        <span class="icon"><i class="fas fa-yen-sign"></i></span>
        基本料金
      </div>
      <div class="item">
        {{company.basic_price}}
      </div>

      <div class="key">
        <span class="icon"><i class="fas fa-desktop"></i></span>
        Webサイト
      </div>
      <div class="item">
        <a :href="company.url">
          <div class="url">{{company.url}}</div>
        </a>
      </div>

      <div class="key">
        <span class="icon"><i class="far fa-comment"></i></span>
        レビュー {{review_all.length}}件
        <div
          @click="go_review(company)"
          class="post_review"
        >
          レビューする
        </div>

      </div>

      <div
        v-for="(review, index) in review_all.slice(0,3)"
        :key="index"
        class="review"
        @click="go_detail(review)"
      >
        <div class="text">{{review.message_title}} </div>
        <star-rating
          v-model="review.review_point"
          :star-size=15
          :read-only="true"
        ></star-rating>
        <div class="nickname">({{review.nickname}})</div>
        <div class="date">{{review.elapsed_time}}</div>
        <div class="right"><i class="fas fa-angle-right"></i></div>
      </div>

    </div>
  </div>
</template>

<script>
import MyHeader from "@/components/MyHeader";
import firebase from "firebase";
export default {
  components: {
    MyHeader
  },
  data() {
    return {
      message: null,
      firestore: firebase.firestore(),
      review_all: [],
      mean_review_poinst: 0
    };
  },
  computed: {
    company() {
      return this.$store.state.company;
    }
  },
  created() {
    window.scrollTo(0, 0);
    console.log(
      "firebase.auth().currentUser: " +
        JSON.stringify(firebase.auth().currentUser)
    );
    this.get_company();
    this.get_review();
  },
  methods: {
    to_phone_number(number) {
      console.log("number: " + number);
      return "tel:" + number;
    },
    get_company() {
      const company_doc = this.firestore
        .collection("companies")
        .doc(this.$route.query.company_name);

      // 会社詳細データを取得
      company_doc
        .get()
        .then(doc => {
          console.log("doc.data(): " + JSON.stringify(doc.data()));
          let company = doc.data();
          this.$store.commit("set_company", company);
        })
        .catch(error => {
          console.log("Error getting documents: ", error);
        });
    },
    get_review() {
      const self = this;
      this.firestore = firebase.firestore();
      this.firestore
        .collection("review")
        .where("company_name", "==", this.$route.query.company_name)
        .get()
        .then(docs => {
          // 時間で並び替え
          docs.forEach(doc => {
            if (self.review_all.length == 0) {
              self.review_all.push(doc.data());
            } else {
              let row = 0;
              for (let i = 0; i < self.review_all.length; i++) {
                self.mean_review_poinst += self.review_all[i]["review_point"];
                if (
                  doc.data()["review_date"] > self.review_all[i]["review_date"]
                ) {
                  break;
                } else {
                  row += 1;
                }
              }
              self.mean_review_poinst =
                Math.round(
                  (self.mean_review_poinst / self.review_all.length) * 2
                ) / 2;
              self.review_all.splice(row, 0, doc.data());
            }
          });
          // 経過時間を計算
          const date = new Date();
          const unix_time = date.getTime();
          self.review_all.forEach(review => {
            review["elapsed_time"] = self.get_elapsed_time(
              unix_time - review["review_date"].toDate().getTime()
            );
          });
          console.log("self.review_all: " + self.review_all);
        })
        .catch(error => {
          console.log("Error getting documents: ", error);
        });
    },
    get_elapsed_time(time) {
      // ミリ秒→秒
      time = time / 1000;
      if (time < 60) {
        return Math.round(time, 0) + "秒前";
      }
      // 秒→分
      time = time / 60;
      if (time < 60) {
        return Math.round(time, 0) + "分前";
      }
      // 分→時
      time = time / 24;
      if (time < 24) {
        return Math.round(time, 0) + "時間前";
      }
      // 時→日
      time = time / 24;
      return Math.round(time, 0) + "日前";
    },
    go_detail(review) {
      console.log("review: " + JSON.stringify(review));
      this.$store.commit("set_review", review);
      this.$router.push("ReviewDatail");
    },
    edit(company) {
      company.number_of_reviews = this.review_all.length;
      this.$store.commit("set_company", company);
      this.$router.push({
        name: "company_edit"
      });
    },
    go_review() {
      let company = this.$store.state.company;
      company.number_of_reviews = this.review_all.length;
      this.$store.commit("set_company", company);
      this.$router.push({
        name: "writeReview"
      });
    }
  }
};
</script>

<style lang="scss">
#company_detail {
  background-color: rgba(0, 0, 0, 0);
  height: 100%;
  .contents {
    margin-top: 2vh;
    .title {
      margin-bottom: 3vh;
      margin-left: 4vw;
      display: table;
      .company_name {
        display: inline-block;
        font-size: 1.2rem;
      }
      .star {
        display: inline-block;
        margin-left: 3vw;
      }
      .star_sum {
        display: inline-block;
        font-size: 0.8rem;
      }
      .vue-star-rating-rating-text {
        display: none;
      }
    }
    .images {
      display: inline-block;
      text-align: center;
      margin-bottom: 3vh;
      img {
        width: 29vw;
        margin-left: 3.5vw;
      }
    }
    .key {
      text-align: left;
      margin-left: 4vw;
      .icon {
        font-size: 1.3rem;
      }
    }
    .item {
      text-align: left;
      color: rgba(0, 0, 0, 0.84);
      margin: 1vh 4vw 5vh 5vw;
      .url {
        display: inline-block;
      }
    }

    .content_top {
      // background-color: white;
      position: relative;
      height: 32vh;
      .company_name {
        font-size: 1.3rem;
        font-weight: bold;
        text-align: left;
        padding-top: 4vh;
        padding-left: 4vw;
      }
      .star-rating {
        position: absolute;
        top: 4.3vh;
        left: 41vw;
        width: 5rem;
        height: 1em;
        font-size: 1rem;
      }
      .star-rating-front {
        position: absolute;
        top: 0;
        left: 0;
        overflow: hidden;
        color: orange;
      }
      .star-rating-back {
        color: #ccc;
      }
      .review_count {
        position: absolute;
        top: 4.7vh;
        left: 63vw;
        font-size: 0.8rem;
      }
      .send_review {
        position: absolute;
        top: 3vh;
        left: 72vw;
        width: 25vw;
        height: 6vh;
        padding: 3px;
        background-color: #f8a9a9;
        border-radius: 10px;
        img {
          position: absolute;
          top: 1vh;
          left: 0vw;
          height: 18.3px;
          width: 13.5px;
        }
        .text {
          position: absolute;
          top: 0.5vh;
          left: 7vw;
          width: 17vw;
          font-size: 0.5rem;
          color: white;
        }
      }
      img {
        height: 13vh;
        width: 22vw;
        object-fit: cover;
        margin: 0 3vw 0 3vw;
      }
      .area {
        .key {
          position: absolute;
          top: 23vh;
          left: 4vw;
          width: 30vw;
          font-weight: bold;
        }
        .value {
          position: absolute;
          top: 23vh;
          left: 40vw;
        }
      }
    }
  }
  .phone_number_contents {
    margin-top: 10vh;
    .phone_number {
    }
    .call {
      display: inline-block;
      margin: 1vh 3vw 0 3vw;
      width: 40vw;
      height: 7vh;
      color: white;
      line-height: 7vh;
      text-align: center;
      border-radius: 10px;
      box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1);
      background-color: rgb(97, 182, 97);
      border-color: rgb(113, 211, 113);
    }
  }
  .edit {
    display: inline-block;
    text-align: center;
    background-color: white;
    font-size: 0.8rem;
    width: 15vw;
    padding: 0.2rem;
    box-shadow: 0 1px 2px gray;
    border-radius: 15px;
  }
  .ok {
    font-size: 0.8rem;
    color: red;
    margin-left: 2vw;
  }
  .post_review {
    display: inline-block;
    margin-left: 2vw;
    margin-bottom: 1vh;
    text-align: center;
    background-color: #f8baeb;
    font-size: 1rem;
    padding: 0.3rem;
    border-radius: 15px;
  }
  .review {
    position: relative;
    background-color: white;
    border-bottom: gray;
    margin: 3px 0;
    padding: 6px 40px 6px 4vw;
    .text {
      font-weight: bold;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .vue-star-rating {
      display: inline-block;
    }
    .vue-star-rating-rating-text {
      margin-top: 0px !important;
      margin-left: 0px !important;
    }
  }
  .nickname {
    display: inline-block;
    margin-left: 3vw;
  }
  .date {
    display: inline-block;
    margin-left: 3vw;
  }
  .right {
    position: absolute;
    top: 5px;
    right: 10px;
    font-size: 1.6rem;
  }
}
</style>
